import * as Yup from 'yup';
// This is the validation of the assign coach form.

export const AssignCoachSchema = Yup.object().shape({
  coach_write_only: Yup.array()
    .min(1, 'At least one coach should be selected')
    .required('Required'),
  coach_message_alert: Yup.bool(),
});
